;(function(global, $){
  var DiscoveryApi = function(options){
		return new DiscoveryApi.init(options);
	}
  var _options = {
		domain: 'https://api.eu.socrata.com/api/catalog/v1',
    filter: '.cat'
	};

  DiscoveryApi.prototype = {
    /*
    * Interroga al dominio principal del socrata para obtener todos los
    * dominos disponibles
    */
    getList: function(){
      var self = this;
      var data = {
       // url: self.domain + '/domains'
        url: self.domain
      };
      return $.ajax(data).promise();
    },
    /*
    * Permite filtar un listado de dominios buscando un texto en el nombre del dominio
    * Ex. .cat
    */
    filterListByDomain: function(list, filter){
      var self = this;
      filter = filter || self.filter;
      var newList = [];
      for(var i = 0, length = list.length; i < length; i++){
        if(list[i].metadata.domain.indexOf(filter) != -1){
          newList.push(list[i]);
        }
      }
      return newList;
    },
    /*
    * Permite filtrar recursos de un listado de dominios
    * return: listado de recursos simplificado
    */
    filterListBy: function(list, options){
      var self = this,
      defer = $.Deferred();
      if(!$.isArray(list)){
        list = [list];
      }
      var data = {
        url: self.domain,
        data: {
          domains: list.join(','),
        }
      };
      if(options){
        $.extend(data.data, options);
      }
      $.ajax(data).promise().then(function(results){
        var simpleList = $.map(results.results, function(val, i){
          return {
            name: val.resource.name,
            type: val.resource.type,
            id: val.resource.id,
            domain: val.metadata.domain
          };
        });
        defer.resolve(simpleList);
      });
      return defer.promise();
    },
    /*
    * De un listado de dominios retorna una matriz con los nombres de dominios
    */
    getDomainsList: function(list){
      var newList = [];
      for(var i = 0, length = list.length; i < length; i++){
        newList.push(list[i].metadata.domain);
      }
      return newList;
    },
    /*
    * Buscar un recurso por el id
    */
    getByResourceName: function(domain, name){
      var data = {
        url: 'https://' +domain + '/api/views.json',
        data: {
          method: 'getByResourceName',
          name: name
        }
      };
      return $.ajax(data).promise();
    },
    /*
    * Retorna el id del último parent de un recurso
    */
    getChildView: function(resource){
      var id = "";
      if(resource.childViews){
        id = resource.childViews[resource.childViews.length-1];
      }else{
        id = resource.id;
      }
      return id;
    },
    /*
    * Retorna el recurso
    */
    getResource: function(domain, name, options){
      var self = this,
      defer = $.Deferred();
      var data = {
        url: 'https://' +domain + '/resource/' + name + ".json"
      };
      if(options){
        data.data = options;
      }
      $.ajax(data).promise().then(function(results){
        var response = {
          results: results,
          url: data.url
        };
        defer.resolve(response);
      });
      return defer.promise();
    },
    /*
    * dado un id de recurso retorna el recurso final
    */
    getFinalResource: function(domain, name, options){
      var self = this,
      defer = $.Deferred();
      self.getByResourceName(domain,name).then(function(results){
        var view = self.getChildView(results);
        self.getResource(domain, view, options).then(function(results){
          defer.resolve(results);
        });
      });
      return defer.promise();
    },
    /*
    *
    */
    getColValues: function(url, nameCol){
      var self = this,
      defer = $.Deferred();
      var data = {
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        url: url + "?$query=SELECT "+nameCol+" GROUP BY "+nameCol+" ORDER BY "+nameCol+ " ASC"
      };

      $.ajax(data).promise().then(function(results){
        var response = {
          results: results,
          nameCol: nameCol
        };
        defer.resolve(response);
      },function(error){
        console.error("Error getColValues per "+nameCol);
        var response = {
          results: [],
          nameCol: nameCol
        };
        defer.resolve(response);
      });
      return defer.promise();
    },
    getGeometryType: function(url){
      var self = this,
      defer = $.Deferred();
      var data = {
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        url: url + "?$query=SELECT * LIMIT 1"
      };

      $.ajax(data).promise().then(function(results){
        var response = {
          results: results
        };
        defer.resolve(response);
      },function(error){
        console.error("Error getColValues per "+nameCol);
        var response = {
          results: [],
          nameCol: nameCol
        };
        defer.resolve(response);
      });
      return defer.promise();
    }
  };

  DiscoveryApi.init = function(options){
  		var self = this;
  		self = $.extend(self, _options, options);
  }

	DiscoveryApi.init.prototype = DiscoveryApi.prototype;

	global.DiscoveryApi = DiscoveryApi;

}(window, jQuery));
